/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {
        p_name_col_name: 'Description (1)',
        p_name_col_width: 240,  // TODO: Wayy to big to make it fit. Auto-resize on columns is needed!

        p_description_col_name: false,

        s_col_name: 'Vendor',
        s_name_col_width: 120,

        bu_col_name: 'Company',
        p_bu_name_col_width: 50,

        show_bu_name_in_review_pages: true,
        p_ddate_pref: [1],
        p_ddate_1_col_name: 'Date',
        p_ddate_1_col_type: 'date',

        p_ddate_1_col_width: 90,

        previous_cat_col_width: 325,
        cat_col_width: 325,

        showSupplierIdPrefixCutoffHack: {type: 'by_split', separator: '|'},

        showBuWithId: true,
        datasetHasMissingBu: true,

        searchConfiguration: 'default_p_desc',

        locale: 'nl-nl',
        currency: 'EUR',

        skipAiTaxonomyMapperModel: true,

        hideCards: [
            'koi-ppv',
            'koi-spend-concentration',
        ],
        staffOnlyCards: [
            'contract-explorer',
        ],
        s_context_2_col_name: 'Short name',

        taxonomy_builder_only_n_cats: true,
        hardcodedOriginalTaxonomyId: 7,
        showSupplierIdInAdvDashboard: true,

        aiRoundTripDemo: true,

        allowReviewDownloadCsv: true,

        disablePreloadAdvDashboard: true,
        showL4InOpportunityDashboard: true,

        synergyDashboardShowBusinessUnits: true,

        enableProcChat: true,
    },
}
